import ConversationDetails from './ConversationDetails.container';

export default ConversationDetails;
